import { Box, Button, FormControl, InputAdornment, OutlinedInput, Typography } from '@mui/material';
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { AlertFillIcon, PhoneIcon } from '~/assets/icons';
import { BASE_COLORS } from '~/utils/constants/common';
import styles from '../auth.module.scss';
import AuthLayout from '../AuthLayout';
import { useNavigate } from 'react-router-dom';
import { adminRoute } from '~/utils/constants/route';
import { useFormik } from 'formik';
import { handleApiError, notify } from '~/utils/helper';
import authApi from '~/apis/auth';
import authValidation from '~/validation/auth';

const cx = classNames.bind(styles);

type ForgotPassworType = {
  phone: string;
};

const initialValues: ForgotPassworType = {
  phone: '',
};

const ForgotPassword = () => {
  const { t } = useTranslation('admin/auth');
  const navigate = useNavigate();

  const form = useFormik<ForgotPassworType>({
    initialValues,
    validateOnChange: false,
    validationSchema: authValidation(t).forgotPassword,
    onSubmit: async (values, { setSubmitting }) => {
      const { phone } = values;

      try {
        setSubmitting(true);
        await authApi.forgertPasswordRequestOTP({ phone });
        notify('success', t('otpConfirmation.otpSendSuccess'));
        navigate(`${adminRoute.base}${adminRoute.optConfirmation}?phone=${phone}`);
      } catch (error) {
        handleApiError(error);
        return;
      } finally {
        setSubmitting(false);
        return;
      }
    },
  });

  return (
    <AuthLayout>
      <Typography className='text-center font-bold text-[#ED1002] lg:text-[40px] xl:text-[44px]'>{`${t(
        'forgotPassword.title'
      ).toUpperCase()}`}</Typography>
      <Box>
        <Typography className='xl1440:text-[20px] whitespace-pre-line text-center'>
          {t('forgotPassword.firstGuide')}
        </Typography>
        <Box className={cx('mt-8', 'input-custom')}>
          <FormControl fullWidth>
            <OutlinedInput
              type='text'
              name='phone'
              value={form.values.phone}
              onChange={form.handleChange}
              placeholder={t('forgotPassword.phonePlaceholder')}
              startAdornment={
                <InputAdornment position='start'>
                  <PhoneIcon fill={BASE_COLORS.RED} />
                </InputAdornment>
              }
            />
            {form.touched.phone && form.errors.phone && (
              <Typography color='error' className='text-sm mt-2 flex items-end gap-[6px]'>
                <AlertFillIcon fill={BASE_COLORS.RED} />
                {form.errors.phone}
              </Typography>
            )}
          </FormControl>
          <Box className='flex justify-evenly mt-10'>
            <Button
              className={`shadow-[0px_4px_4px_0px_#00000040] text-[${BASE_COLORS.BLUE_BOLD}] lg:text-[16px] xl1440:text-[18px] px-6`}
              onClick={() => {
                navigate(`${adminRoute.base}${adminRoute.login}`);
              }}
            >
              {t('forgotPassword.cancel')}
            </Button>
            <Button
              className='shadow-[0px_4px_4px_0px_#00000040] bg-[#ED1002] text-white lg:text-[16px] xl1440:text-[18px] px-6 hover:bg-[#ED1002]'
              onClick={() => form.handleSubmit()}
              disabled={form.isSubmitting}
            >
              {t('forgotPassword.sendOtp')}
            </Button>
          </Box>
        </Box>
      </Box>
    </AuthLayout>
  );
};

export default ForgotPassword;
